import { LegalLayout } from "@/components/legal/LegalLayout";
import { useI18n } from "@/i18n";

export default function Cookies() {
  const { t } = useI18n();
  return <LegalLayout page="cookies" path="/cookies" content={t("legal.cookies")} testid="cookies-page" />;
}
